import React from "react";
import "./Button.css";

interface ButtonProps {
  classStyle?: string;
  text: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  type?: "submit" | "reset" | "button";
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  loading?: boolean;
  disabled?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      classStyle,
      text,
      onClick,
      type,
      startIcon,
      endIcon,
      loading = false,
      disabled = false,
    },
    ref,
  ) => {
    return (
      <div className="button-wrapper">
        <button
          ref={ref}
          className={`custom-button ${classStyle ? "custom-clear" : "custom-submit"} ${
            loading ? " loader-btn" : startIcon ? "startIcon-css" : ""
          }`}
          type={type}
          disabled={loading || disabled}
          onClick={onClick}
        >
          {loading ? (
            <p>
              <span className="button-loader">
                <span></span>
                <span></span>
                <span></span>
              </span>
            </p>
          ) : (
            <>
              {startIcon && (
                <span className="button-wrapper-startIcon">{startIcon}</span>
              )}
              <span className="button-text">{text}</span>
              {endIcon && (
                <span className="button-wrapper-endIcon">{endIcon}</span>
              )}
            </>
          )}
        </button>
      </div>
    );
  },
);

export default Button;
